var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.detail)}})])}
var staticRenderFns = []

export { render, staticRenderFns }